// extracted by mini-css-extract-plugin
module.exports = {"text":"settings_text__26phf","return":"settings_return__2VJt_"};